import React from 'react';
import { useGetOfficeBrokers } from '@converge/graphql';
import { BrokersDialog } from './shared/brokers-dialog';

interface BrokersByOfficeDialogProps {
  open: boolean;
  onClose: () => void;
  officeName: string;
  officeId: string;
  entityId?: string; // Optional for backward compatibility
}

export const BrokersByOfficeDialog: React.FC<BrokersByOfficeDialogProps> = ({
  open,
  onClose,
  officeName,
  officeId,
  entityId,
}) => {
  // Use office brokers query if entityId is available
  const useNewQuery = !!entityId;

  // Query for office brokers following Neo4j structure
  const {
    brokers: fetchedBrokers,
    loading,
    error,
  } = useGetOfficeBrokers({
    officeId,
    enabled: useNewQuery && open && !!officeId && !!entityId,
  });

  return (
    <BrokersDialog
      open={open}
      onClose={onClose}
      title={
        officeName.toLowerCase().includes('office')
          ? officeName
          : `${officeName} Office`
      }
      testId="office-members-dialog"
      loading={loading}
      error={error}
      fetchedBrokers={fetchedBrokers}
      useNewQuery={useNewQuery}
      noDataMessage="No brokers found for this office."
    />
  );
};

export default BrokersByOfficeDialog;
